import { requestWithToken } from '../utilities/request';
const path = '/api/private/fields';

/**
 * オペレータ一覧取得
 * api :GET, '/api/private/fields/:field_id/crane_operator_schedules/list', 'オペレータ情報取得API'
 * @param fieldId {int}
 * @param param {object}
 */
const list = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/crane_operator_schedules/list`),
    params: param,
  });
};

/**
 * オペレータ一登録
 * api :POST, '/api/private/fields/:field_id/crane_operator_schedules', '揚重機オペレータ登録API'
 * @param fieldId {int}
 * @param param {object}
 */
const create = (fieldId, param) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${fieldId}/crane_operator_schedules`),
    data: param,
  });
};

/**
 * オペレータ一更新
 * api :PATCH, '/api/private/fields/:field_id/crane_operator_schedules/:id', '指定したIDのデータを更新します'
 * @param param {object}
 */
const update = param => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${param.field_id}/crane_operator_schedules/${param.id}`),
    params: param,
  });
};

/**
 * オペレータ履歴一覧取得
 * api :GET, '/api/private/fields/:field_id/crane_operator_schedules/histories', '揚重機オペレータ履歴取得API'
 * @param fieldId {int}
 * @param param {object}
 */
const histories = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/crane_operator_schedules/histories`),
    params: param,
  });
};

/**
 * オペレータ設定削除
 * api :DELETE, '/api/private/fields/:field_id/crane_operator_schedules/:id', '揚重機オペレータ削除API'
 * @param fieldId {int}
 */
const destroy = (fieldId, id) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`/${fieldId}/crane_operator_schedules/${id}`),
  });
};

export const CraneOperatorScheduleService = {
  list,
  create,
  update,
  histories,
  destroy,
};
export default CraneOperatorScheduleService;



// WEBPACK FOOTER //
// ./src/services/CraneOperatorSchedules.js